<template>
    <div>
        <div class="data-form">
            <ValidationObserver ref="importForm">
                <div class="row">
                    <div class="col-12">
                        <ValidationProvider name="file" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('excel_file')">
                                <div class="d-flex custom-file-upload">
                                    <b-form-file
                                        accept=".xlsx,.xls"
                                        v-model="defineForm.file"
                                        :state="errors[0] ? false : null"
                                        :placeholder="$t('select_file')"
                                        :drop-placeholder="$t('drop_file')"
                                        ref="fileInput"
                                        multiple></b-form-file>
                                    <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}</b-button>
                                </div>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 d-flex justify-content-center">
                        <DownloadExcelTemplate :code="'parameter_items_excel_import'"/>
                        <processing-button :processing="processing"
                                           :label="$t('import')"
                                           variant="primary"
                                           @click="sendForm"/>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>
<script>
import ProcessingButton from "@/components/elements/ProcessingButton";
import ParameterItemService from "@/services/ParameterItemService";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import DownloadExcelTemplate from "@/components/interactive-fields/DownloadExcelTemplate.vue";

export default {
    name: "ImportExcel",
    components: {
        DownloadExcelTemplate,
        ProcessingButton,
        ValidationObserver,
        ValidationProvider,
    },

    data() {
        return {
            defineForm: {
                file: null
            },
            processing: false
        }
    },
    methods: {
        async sendForm() {
            const isValid = await this.$refs.importForm.validate();
            if (isValid) {
                this.processing = true;
                let formData = new FormData();
                let fileToUpload = Array.isArray(this.defineForm.file) ? this.defineForm.file[0] : this.defineForm.file;
                formData.append('file', fileToUpload);

                ParameterItemService.importExcel(formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.$emit('successProcess');
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.importForm);
                    })
                    .finally(() => {
                        this.processing = false;
                    });

            }
        },
    }
}
</script>
